import { call, put, select, all } from "redux-saga/effects";

// import { getAccumulatedUsage as getAccumulatedUsagePromise } from "@gcloud-npm/adabyron.client.consumos.mis-consumos.acumulado";
import { getAccumulatedUsage as getAccumulatedUsagePromise } from "@/adabyron/telcol/consumos/mis-consumos/acumulado";
// import { getDetailedUsage as getDetailedUsagePromise } from '@gcloud-npm/adabyron.client.consumos.mis-consumos.detallado';
import { getDetailedUsage as getDetailedUsagePromise } from "@/adabyron/telcol/consumos/mis-consumos/detallado";
import { checkMocks } from "../utils/commonUtils";
import { actions as usagesActions } from "@/reducers/usages";
import { MOBILE_PREPAID } from "@/constants/constants";
import { handleSagaError } from "@/sagas/index";
import { allSettled } from "@/bit/sagas/utils.sagas.all-seatled";

import {
  normalizeAccUsage,
  calculateMainMobileLine,
  normalizeDetailedByType,
} from "@/sagas/normalizers/usagesNormalizer";
import { normalizeAccUsagePrepaid } from "@/sagas/normalizers/prepaidNormalizer";
import { getUsageType } from "@/utils/dataHandlers/UsageDataHandler";

const contextStore = (state) => state.main.context;
const getAccumulatedUsages = (state) => state.usages.accumulatedUsages;
const getAccumulatedUsagesPrepaid = (state) =>
  state.prepaid.accumulatedUsagesPrepaid;
const getHiredProducts = (state) => state.product.hiredProducts;
const getDetailedUsages = (state) => state.usages.detailedUsages;
const getCycleInfo = (state) => state.usages.productsCycleInfo;

const getSlideActive = (state) => state.ui.myDataSlide;

const preparePromisesAccumulatedUsage = (
  dataForPromises,
  period,
  promisegetAccumulatedUsage
) => {
  const entry_promises = {};
  dataForPromises.forEach(
    (item) =>
      (entry_promises[`${item.productId}${period}`] = {
        promise: promisegetAccumulatedUsage,
        payload: {
          productIds: item.productId,
          month: period ? period : "0",
        },
        ep: "getAccumulatedUsagePromise",
      })
  );
  return entry_promises;
};

export function* getAllAccumulatedUsagesData({
  handlingCode = 0,
  array2Fetching,
  period = 0,
}) {
  try {
    const MOCK_INFO = "getAccumulatedUsage";
    // When not array2Fetching from args, we need allAccumulated
    const context = yield select(contextStore);
    const array2FetchingPrepaid = [];
    // yield put(usagesActions.getAllAccumulatedUsages());
    if (!array2Fetching) {
      array2Fetching = [];
      let myProducts = yield select(getHiredProducts);
      if (myProducts.length > 0) {
        myProducts.forEach((bundle) => {
          const { childProductId } = bundle;
          childProductId.forEach((itemChild) => {
            if (itemChild.kindProduct !== "internet") {
              const newItemChild = {
                ...itemChild,
                bundleId: bundle.productId,
              };
              if (bundle.productType !== MOBILE_PREPAID) {
                array2Fetching.push(newItemChild);
              }
            }
          });
        });
      }
    }

    let newResPrepaid = {
      accUsagesPrepaid: null,
      allRequestesPrepaid: false,
    };

    let newRes = {
      accUsages: null,
      allRequested: false,
    };
    const accumulatedUsagesAlreadyFetched = yield select(getAccumulatedUsages);
    const onlyWhatWeDontHave = [];
    array2Fetching.forEach((itemForFetch) => {
      const gotItBefore = accumulatedUsagesAlreadyFetched.find(
        (usage) => usage.productId === itemForFetch.productId
      );
      if (!gotItBefore || !gotItBefore.period || !gotItBefore.period[period]) {
        onlyWhatWeDontHave.push(itemForFetch);
      }
    });

    // we have to filter before do it
    if (onlyWhatWeDontHave && onlyWhatWeDontHave.length > 0) {
      let moduleConsumo = yield call(() =>
        import("@/adabyron/telcol/consumos/mis-consumos/acumulado")
      );
      let promisegetAccumulatedUsage = moduleConsumo.getAccumulatedUsage;

      const allpromises = preparePromisesAccumulatedUsage(
        onlyWhatWeDontHave,
        period,
        promisegetAccumulatedUsage
      );
      const responses = yield call(allSettled, {
        promisesConfig: allpromises,
        context,
      });
      let allRequested = true;
      const allProductsCycleInfo = [];
      responses.forEach((response, index) => {
        const currentItem = onlyWhatWeDontHave[index];
        if (response?.resp?.datos) {
          const { bundleId } = currentItem;
          const { accUsageNormalized, productsCycleInfo } = normalizeAccUsage(
            response?.resp?.datos,
            currentItem
          );
          const gotItBefore = accumulatedUsagesAlreadyFetched.find(
            (usage) => usage.productId === accUsageNormalized.productId
          );
          // tratamiento de usages
          if (!gotItBefore) {
            accumulatedUsagesAlreadyFetched.push(accUsageNormalized);
          }

          accumulatedUsagesAlreadyFetched.map((usage) => {
            if (!Array.isArray(usage.period)) {
              usage.period = [];
            }
            if (usage.productId === accUsageNormalized.productId) {
              const {
                data,
                dataRoaming,
                others,
                productId,
                totalExtra,
                sms,
                voice,
              } = accUsageNormalized;
              usage.period[period] = {
                data,
                dataRoaming,
                others,
                productId,
                totalExtra,
                sms,
                voice,
              };
            }
            return { ...usage };
          });

          // tratamiento productCycle
          if (productsCycleInfo) {
            const exist = allProductsCycleInfo.find(
              (item) => item.productId === bundleId
            );
            if (!exist) {
              allProductsCycleInfo.push({
                ...productsCycleInfo,
                productId: bundleId,
              });
            }
          }
        } else {
          allRequested = false;
        }
      });
      newRes = {
        accUsages: accumulatedUsagesAlreadyFetched,
        allProductsCycleInfo,
        allRequested,
        period,
      };
      // Decidimos cual es la línea de más peso
      const hiredProducts2Map = yield select(getHiredProducts);
      const finalProductId = calculateMainMobileLine(
        accumulatedUsagesAlreadyFetched,
        hiredProducts2Map
      );
      if (finalProductId && finalProductId.length > 0) {
        // si conseguimos sacar alguno digo cual es la principal
        // yield put(productsActions.setMainMobileLine(finalProductId));
      }
      // llamo tambien a la de bonos para que se vaya haciendo tambien
      //yield put(productsActions.getAllBonus());
      yield put(usagesActions.setAllAccumulatedUsages(newRes));
    } else {
      yield put(usagesActions.getAllAccumulatedUsagesFetched());
    }
  } catch (error) {
    yield handleSagaError(
      "getAllAccumulatedUsages",
      error,
      "ERROR",
      handlingCode,
      null
    );
  }
}

export function* getMyUsages({ handlingCode = 0, productId, period }) {
  try {
    const MOCK_INFO = "getAccumulatedUsage";
    console.log("paso mock");
    const context = yield select(contextStore);
    let hiredProducts = yield select(getHiredProducts);
    // MOCK
    // let hiredProducts = getMyProductsMock2.datos;
    // hiredProducts = normalizeClientProduct(hiredProducts);

    let currentItem = null;
    let dadItem = null;
    if (Array.isArray(hiredProducts) && hiredProducts.length > 0) {
      hiredProducts.forEach((bundle) => {
        const { childProductId } = bundle;
        if (Array.isArray(childProductId) && childProductId.length > 0) {
          childProductId.forEach((item) => {
            if (item.productId === productId) {
              currentItem = item;
              dadItem = bundle;
            }
          });
        }
      });
    }

    // get a device with this productIds

    const accumulatedUsagesFetched = yield select(getAccumulatedUsages);
    let productsCycleInfoFetched = null;

    let haveThisAccUsage =
      accumulatedUsagesFetched &&
      accumulatedUsagesFetched.find((usage) => usage.productId === productId);

    if (
      haveThisAccUsage &&
      haveThisAccUsage.period &&
      Array.isArray(haveThisAccUsage.period)
    ) {
      if (!haveThisAccUsage.period[period]) {
        haveThisAccUsage = false;
      }
    }

    if (currentItem && dadItem) {
      let res = {};
      let finalAccUsageNormalized = null;
      let mainAccumulatedData = null;
      if (!haveThisAccUsage) {
        const data = { productIds: productId, month: period ? period : "0" };

        haveThisAccUsage =
          accumulatedUsagesFetched &&
          accumulatedUsagesFetched.find(
            (usage) => usage.productId === productId
          );
        // yield put(usagesActions.getMyUsages());
        if (
          !haveThisAccUsage ||
          !haveThisAccUsage.period ||
          !haveThisAccUsage.period[0]
        ) {
          let mainAccumulated = checkMocks(MOCK_INFO);
          if (mainAccumulated === null) {
            mainAccumulated = yield call(getAccumulatedUsagePromise, {
              data: { productIds: productId, month: 0 },
              context,
            });
          }
          mainAccumulatedData = normalizeAccUsage(
            mainAccumulated.datos,
            currentItem
          );
          finalAccUsageNormalized = mainAccumulatedData.accUsageNormalized;

          if (!haveThisAccUsage) {
            accumulatedUsagesFetched.push(finalAccUsageNormalized);
          }
          accumulatedUsagesFetched.map((usage) => {
            if (!Array.isArray(usage.period)) {
              usage.period = [];
            }
            if (usage.productId === productId) {
              usage.period[0] = {
                data: finalAccUsageNormalized.data,
                dataRoaming: finalAccUsageNormalized.dataRoaming,
                others: finalAccUsageNormalized.others,
                productId: finalAccUsageNormalized.productId,
                totalExtra: finalAccUsageNormalized.totalExtra,
                sms: finalAccUsageNormalized.sms,
                voice: finalAccUsageNormalized.voice,
              };
            }
            return { ...usage };
          });
        }

        let accumulated = checkMocks(MOCK_INFO);
        if (accumulated === null) {
          accumulated = yield call(getAccumulatedUsagePromise, {
            data,
            context,
          });
        }
        const accumulatedData = normalizeAccUsage(
          accumulated.datos,
          currentItem
        );
        if (period && period !== "0" && mainAccumulatedData) {
          accumulatedData.productsCycleInfo =
            mainAccumulatedData.productsCycleInfo;
        }
        finalAccUsageNormalized = accumulatedData.accUsageNormalized;
        const { productsCycleInfo } = accumulatedData;

        accumulatedUsagesFetched.map((usage) => {
          if (!Array.isArray(usage.period)) {
            usage.period = [];
          }
          if (usage.productId === productId) {
            usage.period[period] = {
              data: finalAccUsageNormalized.data,
              dataRoaming: finalAccUsageNormalized.dataRoaming,
              others: finalAccUsageNormalized.others,
              productId: finalAccUsageNormalized.productId,
              totalExtra: finalAccUsageNormalized.totalExtra,
              sms: finalAccUsageNormalized.sms,
              voice: finalAccUsageNormalized.voice,
            };
          }
          return { ...usage };
        });
        // tratamiento productCycle
        if (productsCycleInfo) {
          productsCycleInfoFetched = yield select(getCycleInfo);
          const exist = productsCycleInfoFetched.find(
            (item) => item.productId === dadItem.productId
          );
          if (!exist) {
            productsCycleInfo.productId = dadItem.productId;
            productsCycleInfoFetched = productsCycleInfo;
          }
        }
      } else {
        productsCycleInfoFetched = yield select(getCycleInfo);
      }
      res = {
        accUsages: accumulatedUsagesFetched,
        allProductsCycleInfo: productsCycleInfoFetched,
        productId: dadItem && dadItem.productId,
        month: period ? period : 0,
      };
      yield put(usagesActions.getMyUsagesSuccess(res));
    }
    return {
      status: "ok",
    };
  } catch (error) {
    const reducerFailureAction = usagesActions.getMyUsagesFailure(error);
    yield handleSagaError(
      "getMyUsages",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
    return {
      status: "ko",
      error,
    };
  }
}

/* __________ ENDS INDIVIDUAL LOGIC __________ */

export function* getDetailedUsagesByType({
  handlingCode = 0,
  productId,
  kindProduct,
  pageNumber,
  period,
  optionSelected,
}) {
  try {
    const MOCK_INFO = "getDetailedUsage";

    // get a device with this productIds
    const detailUsageFetched = yield select(getDetailedUsages);
    const context = yield select(contextStore);
    const haveThisDetUsage =
      detailUsageFetched &&
      detailUsageFetched.find((usage) => usage.productId === productId);
    const haveThisDetUsageByType = false;
    const res = {};
    let detailedUsageNormalized = null;
    const alreadyRequest = false;
    if (!haveThisDetUsageByType && !alreadyRequest) {
      try {
        res.detailedUsages = [];
        const usageType = getUsageType(optionSelected, kindProduct);
        const data = {
          productIds: productId,
          mode: optionSelected === 99 ? "soloUsoConCoste" : "todosLosUsos",
          useType: optionSelected === 99 ? undefined : usageType,
          pageNumber: pageNumber,
          month: period ? period : "0",
        };
        const detailedResponse = yield call(getDetailedUsagePromise, {
          data,
          context,
        });

        detailedUsageNormalized = normalizeDetailedByType(
          detailedResponse.datos,
          //dataMocked,
          optionSelected,
          haveThisDetUsage,
          kindProduct,
          productId
        );
      } catch (error) {
        detailedUsageNormalized = [];
        yield put(usagesActions.failuregetDetailedUsageOfProducts(error));
      }
      yield put(
        usagesActions.getDetailedUsagesByTypeSuccess(detailedUsageNormalized)
      );
    }
  } catch (error) {
    const reducerFailureAction =
      usagesActions.getDetailedUsagesByTypeFailure(error);
    yield handleSagaError(
      "getDetailedUsagesByType",
      error,
      "ERROR",
      handlingCode,
      reducerFailureAction
    );
  }
}
